import { X, Folder, Image, MessagesSquare, FileText, FileArchive, SendHorizontal, type LucideIcon } from 'lucide-react';

// LINEのブランドロゴは既存SVGを使う。
const lucideIcons: Partial<Record<string, { component: LucideIcon; width: number; height: number; color: string }>> = {
  close: { component: X, width: 24, height: 24, color: 'var(--color-neutral)' },
  folder: { component: Folder, width: 20, height: 16, color: 'var(--color-neutral-550)' },
  image: { component: Image, width: 24, height: 24, color: 'var(--color-neutral)' },
  message: { component: MessagesSquare, width: 25, height: 24, color: 'white' },
  pdf: { component: FileText, width: 24, height: 24, color: 'var(--color-neutral)' },
  zip: { component: FileArchive, width: 24, height: 24, color: 'var(--color-neutral)' },
  sendMessage: { component: SendHorizontal, width: 24, height: 24, color: 'currentColor' },
};

export default lucideIcons;
